import React, { useEffect, useRef } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import i18n from 'i18next';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import Loader from '../../components/Loader/Loader';
import ConfirmationScreen from '../../components/ConfirmationScreen/ConfirmationScreen';
import identityActions from '../../redux/actions/identity.actions';
import authActions from '../../redux/actions/auth.actions';
import alertsActions from '../../redux/actions/alerts.actions';
import cookieHelper from '../../helpers/cookieHelper';
import redirectHelper from '../../helpers/redirectHelper';
import { REQUEST_STATUS } from '../../models/common.model';

const CertificateInviteTransactionPage = () => {
  const match = useRouteMatch();
  const history = useHistory();
  const { search } = useLocation();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { role, transactionId } = match.params;
  const pin = new URLSearchParams(search).get('pin');
  const workspace = new URLSearchParams(search).get('workspace');
  const prevAcceptStatus = useRef(null);
  const prevTokenStatus = useRef(null);

  const { acceptCertificateInvitationStatus, acceptCertificateInvitationErrors, certificateInvitationIdentityId } =
    useSelector((state) => state.identity);
  const { tokenStatus } = useSelector((state) => state.auth);

  useEffect(() => {
    if (!transactionId || !role) {
      history.push(`/${i18n.language}`);
    } else {
      dispatch(authActions.checkTokenStatus(['AUTH_USER_GET_PROFILE']));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (prevTokenStatus.current === REQUEST_STATUS.PENDING) {
      if (tokenStatus === REQUEST_STATUS.SUCCESS) {
        dispatch(identityActions.acceptCertificateInvitation(transactionId, role, pin));
      } else if (tokenStatus === REQUEST_STATUS.ERROR) {
        redirectHelper.setRedirect(window.location.pathname + window.location.search);
        history.push(`/${i18n.language}`);
      }
    }
    prevTokenStatus.current = tokenStatus;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokenStatus]);

  useEffect(() => {
    if (prevAcceptStatus.current === REQUEST_STATUS.PENDING) {
      if (acceptCertificateInvitationStatus === REQUEST_STATUS.SUCCESS) {
        if (certificateInvitationIdentityId?.identityId) {
          cookieHelper.setCookie('activeIdentity', certificateInvitationIdentityId.identityId);
        }
        const appPath = workspace || 'drive';
        redirectHelper.setRedirect(`${process.env.REACT_APP_APP_URL}/${appPath}?s=joinWorkspace`);
        redirectHelper.redirect();
      } else if (acceptCertificateInvitationStatus === REQUEST_STATUS.ERROR) {
        const firstCode = acceptCertificateInvitationErrors?.[0]?.code || null;
        switch (firstCode) {
          case 'NOT_FOUND':
            dispatch(alertsActions.error(t('inviteWorkspacePage.inviteNotFound')));
            break;
          default:
            dispatch(alertsActions.error(t('inviteWorkspacePage.internalError')));
            break;
        }
        history.push(`/${i18n.language}`);
      }
    }
    prevAcceptStatus.current = acceptCertificateInvitationStatus;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [acceptCertificateInvitationStatus]);

  return (
    <Container className="d-flex flex-column h-100">
      <Row>
        <Col>
          <Header redirectType="register" noRedirect />
        </Col>
      </Row>
      <Row className="flex-fill align-items-center">
        <Col>
          {acceptCertificateInvitationStatus === REQUEST_STATUS.ERROR ? (
            <ConfirmationScreen
              imgSrc="/images/error.svg"
              header={t('documentInvitePage.fetchInvitationError')}
            />
          ) : (
            <Loader />
          )}
        </Col>
      </Row>
      <Row>
        <Col>
          <Footer />
        </Col>
      </Row>
    </Container>
  );
};

export default CertificateInviteTransactionPage;
